import { html, render } from "lit-html";
import { createRef, ref } from "lit-html/directives/ref.js";
import { translate } from "@escapio/shared/l10n/translate";
import { stateful } from "@escapio/shared/components/element-builder";
import "@escapio/portal/components/InformationDropdown";

customElements.define(
	"esc-escapio-deal-discount-info",
	stateful(
		class extends HTMLElement {
			static getInitialState() {
				return {
					showDropdown: false,
				};
			}

			connectedCallback() {
				this.buttonRef = createRef();
				this.dropDownRef = createRef();
			}

			render() {
				render(
					html`<button
							class="escapio-deal-discount-info__toggle-button"
							@click=${this.onButtonClick}
							button-aria-label="${translate(
								"escapio_deal_discount_info_aria_label",
							)}"
							${ref(this.buttonRef)}
						>
							<i class="fa fa-info-circle"></i>
						</button>
						<esc-information-dropdown
							?open=${this.showDropdown}
							@change=${this.onDropdownChange}
							info-text=${translate("escapio_deal_discount_info_text")}
							${ref(this.dropDownRef)}
						></esc-information-dropdown>`,
					this,
					{ host: this },
				);
			}

			onDropdownChange({ detail }) {
				this.showDropdown = detail.open;
			}

			onButtonClick(event) {
				event.preventDefault();
				event.stopPropagation();

				this.showDropdown = !this.showDropdown;
				if (this.showDropdown) {
					const { left } = this.buttonRef.value.getBoundingClientRect();
					this.style.setProperty(
						"--escapio-deal-discount-info-anchor-button-left",
						`${left}px`,
					);
				}
			}
		},
	),
);
